export class BuyerDto {
    id: number;
    buyer: string;
    filePath: string;
    fileName: string;
    originalname: number;
    status: string;
    createdUser: string;
    updatedUser: string;
    isActive?: boolean
    versionFlag?: number;
    constructor(id: number, buyer: string, originalname: number, status: string,
        updatedUser: string, filePath: string, fileName: string, createdUser: string, isActive?: boolean, versionFlag?: number) {
        this.id = id;
        this.buyer = buyer;
        this.filePath = filePath
        this.fileName = fileName;
        this.updatedUser = updatedUser;
        this.createdUser = createdUser;
        this.isActive = isActive;
        this.versionFlag = versionFlag;
        this.originalname = originalname
        this.status = status;
    }
}
